import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  name: null,
  role: null,
  email: null,
  status: null,
  profile: null,
  document: null,
  interestedIn: null,
  profileImage: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const {
        token,
        name,
        role,
        email,
        status,
        profile,
        document,
        interestedIn,
        profileImage,
      } = action.payload;
      state.token = token;
      state.name = name;
      state.role = role;
      state.email = email;
      state.status = status;
      state.profile = profile;
      state.document = document;
      state.interestedIn = interestedIn;
      state.profileImage = profileImage;
    },
    logout: (state) => {
      // Reset all fields to null
      Object.keys(state).forEach((key) => {
        state[key] = null;
      });
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
